import { BlocksIconMap } from 'blocks-nextjs/blocks-web-components/components/icon/icons/map';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMap = createComponent({ react: React, tagName: 'cat-icon-map', elementClass: BlocksIconMap });
